import { userPreferenceScopeParam } from '../../../shared/constants/user-preferences';
import { FeatureFlagCollection } from '../../../shared/interfaces/feature-flag.interface';
import { IUserOptinFeatureSettings } from '../interfaces/user-optin.interface';

export enum UserOptinFeatures {
  verticalNavigation = 'verticalNavigation',
}

export const UserOptinFeatureSettings: ReadonlyArray<IUserOptinFeatureSettings> = Object.freeze([
  {
    feature: UserOptinFeatures.verticalNavigation,
    featureFlag: FeatureFlagCollection.verticalNavigationOptin,
    scopeParam: userPreferenceScopeParam.verticalNavigationEnabled,
    defaultOptedIn: true,
  },
]);
